import React, { useState } from 'react';
import { Button, Typography, Box } from '@mui/material';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { formatDuration } from '../../utils/timeUtils';

const EmailPreview = ({ selectedDate, monthlyPlanning, selectedReleveCodes }) => {
  const [emailPreview, setEmailPreview] = useState('');

  const prepareEmail = () => {
    // Vérifier si aucun code n'est sélectionné et prendre tous les codes si c'est le cas
    const selectedCodes = selectedReleveCodes.length > 0 
      ? selectedReleveCodes 
      : Object.keys(monthlyPlanning);

    // Créer un objet pour stocker les heures par date et par code
    let emailData = {};

    // Filtrer et traiter les entrées
    const filteredEntries = Object.entries(monthlyPlanning)
      .filter(([code]) => selectedCodes.includes(code));

    filteredEntries.forEach(([code, data]) => {
      if (Array.isArray(data.entries)) {
        data.entries.forEach(entry => {
          const date = format(new Date(entry.date), 'dd/MM/yyyy');
          if (!emailData[date]) {
            emailData[date] = { hours: {} };
          }
          emailData[date].hours[code] = (emailData[date].hours[code] || 0) + entry.hours;
        });
      }
    });

    // Trier les dates dans l'ordre croissant
    const sortedDates = Object.keys(emailData).sort((a, b) => {
      const dateA = new Date(a.split('/').reverse().join('-'));
      const dateB = new Date(b.split('/').reverse().join('-'));
      return dateA - dateB;
    });

    // Créer le contenu de l'email
    let emailContent = `Subject: Pointage du Mois ${format(selectedDate, 'MMMM yyyy', { locale: fr })}\n\n`;
    emailContent += 'Bonjour,\nVeuillez trouver ci-joint mon pointage pour le mois :\n\n';
    emailContent += '<table style="border-collapse: collapse; width: 100%;">';
    emailContent += '<tr><th style="border: 1px solid black; padding: 8px;">Date</th>' + 
      selectedCodes.map(code => 
        `<th style="border: 1px solid black; padding: 8px;">${code}</th>`
      ).join('') + 
      '<th style="border: 1px solid black; padding: 8px;">Total</th></tr>';

    // Avant de créer le tableau, initialiser les totaux
    const totals = {};
    selectedCodes.forEach(code => {
      totals[code] = 0;
    });

    // Pendant la boucle des dates, mettre à jour les totaux
    sortedDates.forEach(date => {
      selectedCodes.forEach(code => {
        const hours = emailData[date].hours[code] || 0;
        totals[code] += hours;
      });
    });

    sortedDates.forEach(date => {
      emailContent += `<tr><td style="border: 1px solid black; padding: 8px;">${date}</td>`;
      
      selectedCodes.forEach(code => {
        const hours = emailData[date].hours[code] || 0;
        emailContent += `<td style="border: 1px solid black; padding: 8px;">
          ${hours > 0 ? formatDuration(hours) : ''}
        </td>`;
      });

      const totalHoursForDate = Object.values(emailData[date].hours)
        .reduce((sum, h) => sum + h, 0);
      emailContent += `<td style="border: 1px solid black; padding: 8px;">
        ${formatDuration(totalHoursForDate)}
      </td></tr>`;
    });

    // Ajouter la ligne des totaux à la fin du tableau
    emailContent += '<tr><td style="border: 1px solid black; padding: 8px; font-weight: bold;">Totaux</td>';
    selectedCodes.forEach(code => {
      emailContent += `<td style="border: 1px solid black; padding: 8px; font-weight: bold;">
        ${totals[code] > 0 ? formatDuration(totals[code]) : ''}
      </td>`;
    });

    // Calculer le total général
    const grandTotal = Object.values(totals).reduce((sum, h) => sum + h, 0);
    emailContent += `<td style="border: 1px solid black; padding: 8px; font-weight: bold;">
      ${formatDuration(grandTotal)}
    </td></tr>`;

    emailContent += '</table>';

    // Mettre à jour la prévisualisation
    setEmailPreview(emailContent);

    // Créer et télécharger le fichier .eml
    const blob = new Blob([emailContent], { type: 'text/html' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'rapport_pointage.eml';
    link.click();
  };

  return (
    <Box>
      <Button onClick={prepareEmail}>Préparer le rapport par email</Button>
      {emailPreview && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="h6">Prévisualisation de l'email</Typography>
          <Box 
            sx={{ mt: 1, p: 2, border: 1, borderColor: 'grey.300', borderRadius: 1 }}
            dangerouslySetInnerHTML={{ __html: emailPreview }} 
          />
        </Box>
      )}
    </Box>
  );
};

export default EmailPreview;
